import { useState } from 'react'

export function useFormSteps() {
  const [step, setStep] = useState(0)

  const nextStep = () => setStep(step + 1)
  const prevStep = () => setStep(step - 1)

  return [step, nextStep, prevStep]
}

// Given a function that sets form data, return an error state and a handler to update the form data.
// The handler takes an event and the current form data as arguments.
// It updates the formData object based on the name and value of the event target.
// TODO: This abstraction is weird, needs work.
export function useWizardForm(setFormData) {
  // TODO: Handle errors in here or consider getting rid entirely.
  const [error, setError] = useState('')

  const updateForm = (e, currentForm) => {
    const val = e?.target?.value || e?.value

    setFormData({ ...currentForm, [e.target.name]: val })
    setError('') // Clear error when typing
  }

  return [error, setError, updateForm]
}
